import { replace, pipe, take, drop, toUpper } from 'ramda';

const capitalize = (str) => pipe(take(1), toUpper, (upperChar) => upperChar + drop(1, str))(str);

const mapTaxonomyDisplayName = pipe(replace(/(_|-)/g, ' '), capitalize);

export default mapTaxonomyDisplayName;
